import React, { useEffect } from "react";
import './Services.css'
import Navigation from "./Navigation";
import Header from "./Header";
import Contact from "./Contact";
import Footer from "./Footer";
import FooterDesc from "./FooterDesc";

const Services = () => {
    useEffect(() => {
        // window.scrollTo(0, 0);
    }, [])
    return (
        <>
            <Navigation />

            <Header />

            <section className="page-section" id="services" style={{ userSelect: "none" }}>
                <div className="container">
                    <div className="text-center">
                    </div>
                    <div className="row text-center">
                        <div className="col-md-4">
                            <span className="fa-stack fa-4x">
                                {/* <i className="fas fa-circle fa-stack-2x text-primary" /> */}
                                {/* <img src="assets/img/services/nails-polish-color.png" alt="Nail art logo" style={{width:"100px"}}/> */}
                                <img src="assets/img/services/nails-color.png" alt="Nail art logo" style={{ width: "80px" }} />
                                {/* <i className="fas fa-palette fa-stack-1x fa-inverse" /> */}
                            </span>
                            <h4 className="my-3">Nail Art</h4>
                            <p className="text-muted">
                                Professional nail art services for stunning, customized designs..
                            </p>
                        </div>
                        <div className="col-md-4">
                            <span className="fa-stack fa-4x">
                                {/* <i className="fas fa-circle fa-stack-2x text-primary" />
                                <i className="fas fa-scissors fa-stack-1x fa-inverse" /> */}
                                <img src="assets/img/services/nails-polish-color.png" alt="Nail art logo" style={{ width: "80px" }} />
                            </span>
                            <h4 className="my-3">Gel Polish</h4>
                            <p className="text-muted">
                                Long-lasting, chip-resistant gel polish for a flawless, high-gloss finish that lasts weeks!.
                            </p>
                        </div>
                        <div className="col-md-4">
                            <span className="fa-stack fa-4x">
                                {/* <i className="fas fa-circle fa-stack-2x text-primary" />
                                <i className="fas fa-scissors fa-stack-1x fa-inverse" /> */}
                                <img src="assets/img/services/cut.png" alt="Nail art logo" style={{ width: "80px" }} />
                            </span>
                            <h4 className="my-3">Nail Cutting and Filling</h4>
                            <p className="text-muted">
                                Expert nail cutting, filling, and artistic nail designs for a flawless look..
                            </p>
                        </div>
                        <div className="col-md-4">
                            <span className="fa-stack fa-4x">
                                {/* <i className="fas fa-circle fa-stack-2x text-primary" />
                                <i className="fas fa-lock fa-stack-1x fa-inverse" /> */}
                                <img src="assets/img/services/beauty.png" alt="Nail art logo" style={{ width: "80px" }} />
                            </span>
                            <h4 className="my-3">Nail Extensions</h4>
                            <p className="text-muted">
                                Enhance your nails with durable, stylish, and natural-looking extensions..
                            </p>
                        </div>
                        <div className="col-md-4">
                            <span className="fa-stack fa-4x">
                                {/* <i className="fas fa-circle fa-stack-2x text-primary" />
                                <i className="fas fa-lock fa-stack-1x fa-inverse" /> */}
                                <img src="assets/img/services/nail-polish-remover.png" alt="Nail art logo" style={{ width: "80px" }} />
                            </span>
                            <h4 className="my-3">Polish Removal</h4>
                            <p className="text-muted">
                                Gentle and efficient polish removal for a flawless finish.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <Contact />

            <FooterDesc />

            <Footer />
        </>
    )
}

export default Services;